import { makeStyles } from '@material-ui/core/styles'

// Styles
export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& section': {
      background: '#eeeeee',
    }
  },
  mainTitle: {
    position: 'relative',
    marginTop: '1rem',
    marginBottom: '4rem',
    letterSpacing: '.8pt',
    fontSize: 38,
    fontFamily: "YuMincho, 游明朝, serif",
  },
  cateTitle: {
    margin: '2rem 0 1rem 0',
    borderLeft: 'solid 5px #3C3C3C',
    paddingLeft: '1rem',
    color: '#000'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  span: {
    color: '#3485BF'
  },
}))